<script setup>
const props = defineProps({
  type: {
    type: String,
  },
  variant: {
    type: String,
  }
})
</script>
<template>
  <div :class="`badge badge-${type}${variant ? `-${variant}` : ''}`">
  <slot></slot>
</div>
</template>
<style scoped>

.badge {
  @apply inline-flex flex-none items-center gap-3 px-[18px]  py-[2.5px] rounded-3xl text-xs;
  @apply bg-secondary-30 text-secondary-60;
}
.badge-course {
@apply bg-secondary-40 text-secondary-70;
}
.badge-workshop {
@apply bg-transparent text-secondary-100 border border-secondary-100;
}
.badge-premium {
@apply bg-b2b-primary-10 text-secondary-100;
}
.badge-list {
@apply bg-secondary-90 text-white;
}
.badge-blog {
@apply bg-secondary-40 text-secondary-80;
}
.badge-secondary {
@apply bg-secondary-40 text-secondary-70;
}
.badge-secondary-dark {
@apply bg-secondary-80 text-secondary-10;
}
.badge-b2b-primary {
@apply bg-b2b-primary-10 text-b2b-primary-50;
}
.badge-b2b-primary-dark {
@apply bg-b2b-primary-50 text-white;
}
.badge-b2c-primary {
@apply bg-b2c-primary-10 text-b2c-primary-50;
}
.badge-b2c-primary-dark {
@apply bg-b2c-primary-50 text-white;
}
.badge-warning {
@apply bg-warning-10 text-warning-50;
}
.badge-warning-dark {
@apply bg-warning-50 text-white;
}
.badge-error {
@apply bg-error-10 text-error-50;
}
.badge-error-dark {
@apply bg-error-50 text-white;
}
.badge-success {
@apply bg-success-10 text-success-50;
}
.badge-success-dark {
@apply bg-success-50 text-white;
}
</style>